// Sugalarm — primary / ghost / danger button.

import type { ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./Button.module.css";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "ghost" | "danger";
  size?: "md" | "sm";
  full?: boolean;
  children: ReactNode;
}

export function Button({
  variant = "primary",
  size = "md",
  full = false,
  children,
  className,
  type = "button",
  ...rest
}: Props) {
  const cls = [
    styles.button,
    styles[variant],
    size === "sm" ? styles.sm : null,
    full ? styles.full : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button type={type} className={cls} {...rest}>
      {children}
    </button>
  );
}
